import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { Table, Container, Segment, List } from 'semantic-ui-react';
import request from 'services/http';
import history from 'services/history';
import { getURLParameters } from 'utils';
import { tap, finalize } from 'rxjs/operators';
import { numFormat } from '@rededompedro/utils';
import { DateTime } from 'luxon';

function dateIdToBR(date) {
    const d = DateTime.fromFormat(String(date), 'yyyyMMdd');
    if (!d.isValid) {
        return '--';
    }
    return d.toFormat('dd/MM/yyyy');
}

export function Detailing(props) {

    const [data, setData] = useState(null);
    const [contaInfo, setContaInfo] = useState(null);

    const urlParams = useMemo(() => getURLParameters(history.location.search), []);

    useEffect(() => {
        if (urlParams) {
            const detailing$ = request({
                url: '/recebiveis/em-aberto/detailing',
                params: urlParams,
            }).pipe(
                tap(({ response }) => setData(response)),
                finalize(() => detailing$.unsubscribe()),
            ).subscribe();
    
            const contaInfo$ = request({
                url: '/common/conta-info',
                params: { id: urlParams['conta_id'] },
            }).pipe(
                tap(({ response }) => setContaInfo(response)),
                finalize(() => contaInfo$.unsubscribe()),
            ).subscribe();
        }
    }, [props, urlParams]);

    const renderRows = useCallback(() => {
        if (!data) {
            return (
                <Table.Row>
                    <Table.Cell
                        colSpan={5}
                        style={{ padding: 50 }}
                        textAlign="center"
                    >Carregando... por favor aguarde.</Table.Cell>
                </Table.Row>
            );
        }

        if (!data.length) {
            return (
                <Table.Row>
                    <Table.Cell
                        colSpan={5}
                        style={{ padding: 50 }}
                        textAlign="center"
                    >Não foram retornados dados.</Table.Cell>
                </Table.Row>
            );
        }

        return data.map((it, i) => (
            <Table.Row key={`detailing-${i}`}>
                <Table.Cell>{dateIdToBR(it.data)}</Table.Cell>
                <Table.Cell>{it.cod_cliente} - {it.cliente ?? '--'}</Table.Cell>
                <Table.Cell>{dateIdToBR(it.vencimento)}</Table.Cell>
                <Table.Cell>{it.tipo_movimento}</Table.Cell>
                <Table.Cell>R$ {numFormat(it.valor)}</Table.Cell>
            </Table.Row>
        ));
    }, [data]);

    return (
        <Container style={{ width: '100%', marginTop: 20, marginBottom: 20 }}>
            <Segment>
                {contaInfo && urlParams && (
                    <List>
                        <List.Item>
                            <List.Icon name='info circle' />
                            <List.Content>Detalhamento de <b>{contaInfo.nome}</b> de {urlParams.period.split(',').map((it) => DateTime.fromISO(it).toFormat('dd/MM/yyyy')).join(' - ')}</List.Content>
                        </List.Item>
                    </List>
                )}
            </Segment>
            <Table>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Data</Table.HeaderCell>
                        <Table.HeaderCell>Cliente</Table.HeaderCell>
                        <Table.HeaderCell>Vencimento</Table.HeaderCell>
                        <Table.HeaderCell>Tipo</Table.HeaderCell>
                        <Table.HeaderCell>Valor</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {renderRows()}
                </Table.Body>
                {data && (
                    <Table.Footer>
                        <Table.Row>
                            <Table.HeaderCell colSpan={4} style={{ textAlign: 'right', fontWeight: 'bold' }}>Total</Table.HeaderCell>
                            <Table.HeaderCell textAlign="left">
                                <b>R$ {numFormat(data.map((it) => it.valor).reduce((a, b) => a + b, 0))}</b>
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Footer>
                )}
            </Table>
        </Container>
    )
}
